import { useEffect } from 'react';

interface UseDocumentTitleOptions {
  restore?: boolean; // Whether to restore original title on unmount
  originalTitle?: string; // Original title to restore to
}

/**
 * Custom hook to manage document title
 * @param title - The title to set
 * @param options - Configuration options
 */
export const useDocumentTitle = (
  title: string, 
  options: UseDocumentTitleOptions = {}
) => {
  const { restore = true, originalTitle = 'CDRPL' } = options;

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    return () => {
      if (restore) {
        document.title = originalTitle || previousTitle;
      }
    };
  }, [title, restore, originalTitle]);
};

export default useDocumentTitle;
